import { restClient } from '../../client';

export const getPublicICSSubscription = async () => restClient.request<{ data: { subscriptionUrl: string; directSubscriptionUrl: string } | null }>('/api/v1/calendar/ics/subscription', { method: 'GET' });
export const addPublicICSSubscription = async () => restClient.request<{ data: { subscriptionUrl: string } }>('/api/v1/calendar/ics/subscription', { method: 'POST' });
export const deletePublicICSSubscription = async () => restClient.request('/api/v1/calendar/ics/subscription', { method: 'DELETE' });
